import React, { useEffect } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import AOS from "aos";

import { Footer } from "./components/Footer/Footer";
import { Navigation } from "./components/Navigation/Navigation";
import { ArticlesProvider } from "./contexts/ArticlesContext";
import { APIConnector } from "./contexts/APIConnector";
import { Homepage } from "./pages/Homepage/Homepage";
import { ArticlePage } from "./pages/ArticlePage/ArticlePage";
import { CategoriesProvider } from "./contexts/CategoriesContext";
import { StageProvider } from "./contexts/StageContext";
import { InstallationProvider } from "./contexts/InstallationContext";
import { ScrollToTop } from "./components/ScrollToTop/ScrollToTop";
import { GoogleAnalytics } from "./components/Tracking/GoogleAnalytics";
import { HelpPage } from "./pages/HelpPage/HelpPage";
import { FeaturesProvider } from "./contexts/FeaturesContext";
import { FilesProvider } from "./contexts/FilesContext";

import { AOS_DURATION, AOS_OFFSET } from "./config";
import "aos/dist/aos.css";
import { AttributesProvider } from "./contexts/AttributesContext";
import { SupportProvider } from "./contexts/SupportContext";

function App() {
  useEffect(() => {
    AOS.init({
      duration: AOS_DURATION,
      once: true,
      offset: AOS_OFFSET,
    });
  });

  return (
    <div className="app">
      <ArticlesProvider>
        <CategoriesProvider>
          <StageProvider>
            <InstallationProvider>
              <FeaturesProvider>
                <FilesProvider>
                  <AttributesProvider>
                    <SupportProvider>
                      <APIConnector />

                      <Router>
                        <ScrollToTop />
                        <GoogleAnalytics />

                        <header>
                          <Navigation />
                        </header>
                        <main>
                          <Switch>
                            <Route path="/article/:id">
                              <ArticlePage />
                            </Route>
                            <Route path="/help">
                              <HelpPage />
                            </Route>
                            <Route path="/">
                              <Homepage />
                            </Route>
                          </Switch>
                        </main>
                        <footer>
                          <Footer />
                        </footer>
                      </Router>
                    </SupportProvider>
                  </AttributesProvider>
                </FilesProvider>
              </FeaturesProvider>
            </InstallationProvider>
          </StageProvider>
        </CategoriesProvider>
      </ArticlesProvider>
    </div>
  );
}

export default App;
